import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export enum TitleSpacing {
  NONE = 0,
  X_SMALL = 8,
  SMALL = 16,
  MEDIUM = 24,
  LARGE = 32,
  X_LARGE = 40,
  XX_LARGE = 48,
}

export enum TitleSize {
  SMALL = 3,
  MEDIUM = 2,
  LARGE = 1,
}

@Component({
  standalone: true,
  selector: 'app-title-section',
  templateUrl: './title-section.component.html',
  styleUrls: ['./title-section.component.css'],
  imports: [CommonModule],
})
export class TitleComponent {
  @Input() title!: string;
  @Input() size: 1 | 2 | 3 = 1;
  @Input() secondaryText!: string;
  @Input() subTitle!: string;
  @Input() body!: string;
  @Input() backButton = false;
  @Input() spacingBottom = TitleSpacing.NONE;
  @Input() testIdPrefix!: string;

  @Output() handlePressBack = new EventEmitter<void>();

  onClick() {
    this.handlePressBack.emit();
  }
}
